import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";

import { MdmCardFormStore } from "../../MdmCardFormStore";
import { FormGrid, FormItem } from "../../types/MdmCardFormTypes";
import * as styles from "./GridView.module.less";

interface PropsGridView {
  form: MdmCardFormStore;
  gridItem: FormGrid;
}

export const GridView: React.FC<PropsGridView> = observer((props) => {
  const { form, gridItem } = props;
  const { meta, items } = gridItem;
  const { visibleKeys } = form;
  const columns = meta.columnsCount ?? 3;
  const gridTemplateColumns: string = new Array<string>(columns)
    .fill("1fr")
    .join(" ");
  const disabled = form.isItemDisabled(gridItem);

  const title = meta.title ? form.evaluateText(meta.title) : null;
  const visibleItems = items.filter(({ key }) => visibleKeys.has(key));

  return (
    <div className={classNames([styles.gridBox, [disabled, styles.disabled]])}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.mainGrid} style={{ gridTemplateColumns }}>
        {visibleItems.map((it) => (
          <div
            key={it.key}
            className={styles.gridItem}
            style={{ gridColumn: mkGridCol(it, columns) }}
          >
            {it.render(form)}
          </div>
        ))}
      </div>
    </div>
  );
});

const mkGridCol = (it: FormItem, columns: number): string | undefined => {
  const { colSpan } = it.meta;
  if (colSpan) {
    const n: number = colSpan === "*" ? columns : colSpan;
    return `span ${n}`;
  }
  return undefined;
};
